<template>
    <div
        class="user-menu"
        :class="{ active: userMenuOpen }"
    >
        <base-user-avatar
            size="small"
            @click="handleUserMenu"
         />
        <transition name="fade">
            <div
                v-show="userMenuOpen"
                class="user-menu-modal icon-menu"
            >
                <ul>
                    <li>
                        <router-link
                            to="/settings"
                            @click.native="handleUserMenu"
                        >
                            <i class="fal fa-cog" /> Settings
                        </router-link>
                    </li>
                    <li>
                        <a href="https://support.fusebox.fm" target="_blank">
                            <i class="fal fa-life-ring" /> Help Center
                        </a>
                    </li>
                    <li>
                        <a
                        @click.prevent="logOut"
                        >
                            <i class="fal fa-sign-out" /> Log Out
                        </a>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    // eslint-disable-next-line require-jsdoc
    data() {
        return {
            userMenuOpen: false,
        };
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        ...mapActions(['logOut']),

        /**
         * Opens user menu
         *
         */
        handleUserMenu() {
            this.userMenuOpen = ! this.userMenuOpen;
        },
    },
};
</script>
